<div class="rvp">
  <div class="rvp-map">
    <div id="test">
      <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>
    </div>
  </div>

  <div class="rvp-top">
    <div class="glass top-pill">
      <button type="button" class="icon-btn back" (click)="goBack()" title="بازگشت" aria-label="بازگشت">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <div class="top-titles">
        <h1>نمایش نقاط روی نقشه</h1>
      </div>
    </div>
  </div>

  <div class="glass rvp-rail">
    <button type="button" class="rail-btn" (click)="changeTail()" [disabled]="layers.length < 2"
      data-tip="تغییر نوع نقشه" aria-label="تغییر نوع نقشه" [attr.aria-pressed]="mapSatelait">
      <img src="assets/Img/layer-icon.png" alt="">
    </button>
  </div>
</div>
